import login from './login'
import nav from './_nav.json'
import activity from './activity'
import dict from './dict.json'
import demo from './demo.json'

export default {
  site_title: 'JDYun.com',
  title: "Système d'Activités JDYun",
  system_demo: 'Démo du Système',
  confirm: 'Confirmer',
  cancel: 'Annuler',
  show: 'Afficher',
  hide: 'Masquer',
  open: 'Ouvrir',
  close: 'Fermer',
  save: 'Enregistrer',
  edit: 'Modifier',
  delete: 'Supprimer',
  add: 'Ajouter',
  search: 'Rechercher',
  query: 'Requête',
  reset: 'Réinitialiser',
  submit: 'Soumettre',
  upload: 'Télécharger',
  download: 'Télécharger',
  export: 'Exporter',
  import: 'Importer',

  started: 'Commencé',
  ended: 'Terminé',
  next: 'Suivant',
  prev: 'Précédent',
  publish: 'Publier',
  input: 'Veuillez saisir {text}',
  select: 'Veuillez sélectionner {text}',
  total: 'Total {total}',
  price: '{price} RMB',
  required: '{text} est requis',
  selected: '{total} {text} sélectionné(s)',
  create: 'Créer',
  free: 'Gratuit',
  charge: 'Payant',
  default: 'Par défaut',
  custom: 'Personnalisé',
  max: 'Maximum',
  min: 'Minimum',
  percent: 'Pourcentage',
  online: 'En ligne',
  offline: 'Hors ligne',
  name: 'Nom',
  remark: 'Remarque',
  tips: 'Conseils',
  header: {
    logout: 'Se déconnecter',
    binding: 'Lier le compte',
    mobile: 'Client marchand mobile',
    register: 'Client mobile',
    tips: 'Activité {name}',
    qrcodeText: '{name} QR code H5',
    qrcodeMiniText: '{name} code mini-programme',
    qrcode: 'Cliquez pour télécharger le QR code',
    qrcodeMini: 'Cliquez pour télécharger le code mini-programme'
  },
  home: {
    title: "Bienvenue sur la plateforme de gestion d'activités Jindouyun",
    sub_title: 'Publiez ici les activités et événements les plus complets et détaillés',
    desc: "Commencez votre parcours d'organisation d'activités depuis la gestion des activités",
    create: 'Créer rapidement une activité'
  },
  user: {
    title: 'Informations de base du compte',
    logo: 'Logo de la marque',
    update: 'Mettre à jour',
    name: "Nom de l'entreprise ou de l'organisation",
    short_name: 'Marque dans la barre de menu supérieure gauche',
    enable: 'Activer la connexion personnalisée',
    web_tips: 'URL de connexion personnalisée',
    copy: "Copier l'URL",
    login: 'Nom de la marque sur la page de connexion',
    login_title: 'Nom du système sur la page de connexion'
  },
  login,
  activity,
  demo,
  ...nav,
  ...dict,
  // CODE_SUCCESS: 2000,
  2000: 'Opération réussie',
  // CODE_ERROR: 5000,
  5000: 'Anomalie de requête réseau, veuillez vérifier votre connexion',
  // CODE_ERROR_PARAMS: 5001,
  5001: 'Erreur de paramètres de requête',
  // URL注册失败
  // CODE_ERROR_URL_REG_FAILURE: 5002,
  5002: "Échec de l'enregistrement URL",
  // CODE_ERROR_NO_PARAM: 5003,
  5003: 'Erreur de paramètre',
  // CODE_ERROR_PERSSION_ERROR: 5004,
  5004: 'Erreur de permission',
  // JWT 验证错误
  // CODE_JWT_ERROR: 5100,
  5100: 'Échec de vérification JWT',
  // CODE_JWT_LOGIN_FAILURE: 5101,
  5101: 'Échec de connexion',
  // JWT Token 无效
  // CODE_JWT_TOKEN_INVALID: 5102,
  5102: 'JWT invalide',
  // CODE_JWT_NO_USER: 5103,
  5103: "L'utilisateur n'existe pas",
  //
  // CODE_PARAMS_TYPE_ERROR_SIZE = 5401
  5401: 'Erreur de paramètre de taille',
  //
  // CODE_PARAMS_TYPE_ERROR_PAGE = 5402
  5402: 'Erreur de paramètre de page',
  //
  // CODE_PARAMS_TYPE_ERROR_QUERY = 5403
  5403: 'Erreur de mot-clé de recherche'
}



// WEBPACK FOOTER //
// ./src/langs/fr/index.js